import { formatMoney } from 'libs/shopify'

function Price({ className = '', price = 0, originalPrice = null, classSize = 'text-sm', classColor = '', saleColorStyle = {}, classOriginalColor = '', salePretext = '' }) {
  const customClass = `price ${className}`
  const isSale = originalPrice && originalPrice !== 0 && originalPrice > price
  const colorSalePrice = isSale ? `${classSize} ${classColor}` : `${classSize}`
  const colorOriginalPrice = classOriginalColor !== '' ? classOriginalColor : 'text-default'
  return (
    <div className={customClass}>
      {isSale ? <span className={`line-through ${colorOriginalPrice} ${classSize}`}>{formatMoney(originalPrice)}</span> : ''}
      <span className={`${colorSalePrice} ${classSize}`} style={saleColorStyle}>{isSale ? salePretext : ''} {formatMoney(price)}</span>
    </div>
  )
}

export default Price
